import { __awaiter } from './_virtual/_tslib.js';

const MILITARY_PROGRAM_ID = "us-military";
const MILITARY_GROUP_ID = "active";
const CUSTOMER_GROUPS_DOMAIN = "https://customer-groups.personalization.vpsvc.com";
const isCustomerInMilitaryGroup = (customerId) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    const authToken = yield getAuthToken();
    try {
        const customerGroupResponse = yield fetch(`${CUSTOMER_GROUPS_DOMAIN}/api/v1/customers/${customerId}/programs`, {
            method: "GET",
            headers: {
                "Authorization": `Bearer ${authToken}`,
                "content-type": "application/json"
            }
        });
        const responseData = yield customerGroupResponse.json();
        const matchingGroup = (_a = responseData.programs.find(program => program.id === MILITARY_PROGRAM_ID)) === null || _a === void 0 ? void 0 : _a.groups.find(group => group.id === MILITARY_GROUP_ID && group.isMember);
        return matchingGroup !== undefined;
    }
    catch (error) {
        console.log("ERROR fetching customer group status: ", error);
        throw error;
    }
});
const getAuthToken = () => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const authResponse = yield fetch('https://oauth.cimpress.io/v2/token', {
            method: "POST",
            headers: {
                "content-type": "application/json",
            },
            body: JSON.stringify({
                client_id: "k59ds594s6znFA37wdNAM8GnO4MI9Ajm",
                client_secret: "fc40b571499710a7511ed6aad1d501cbf4884e7c57b66442c7c5ec1306fe7c9849679fccfc0759e9bc033bf8a42f65a24a10014e1a994a148508c8fc89d2e9a1",
                audience: 'https://api.cimpress.io/',
                grant_type: 'client_credentials',
            })
        });
        const responseBody = yield authResponse.json();
        return responseBody['access_token'];
    }
    catch (error) {
        console.log("ERROR retreiving access token: ", error);
    }
});

export { isCustomerInMilitaryGroup };
//# sourceMappingURL=CustomerGroupService.js.map
